import { NOMINEE_DIRECTOR } from '@/constants/config';
import {formatDate, generateRandomUniqueId} from '@/helpers';

const getDirectorData = data => ({
    'user_id': data.director_user.id,
    'name'   : data.director_user.user_info?.legal_name ?? data.director_user.name,
    'nric'   : data.director_user.user_info.NRIC,
    'email'  : data.director_user.email,
});

const getNominatorData = data => {
    if(data.is_existing_nominator) {
        return {
            user_id: data?.shareholder?.user?.user_id,
            reference_id: data?.shareholder?.reference_id,
            name: data?.shareholder?.user?.user_info?.legal_name ?? data?.shareholder?.user?.name,
            email: data?.shareholder?.user?.email,
            nric: data?.shareholder?.user?.user_info.NRIC
        };
    }
    return null;
};

const localizeChangeNominator = changeNominatorData => ({
    _id: generateRandomUniqueId(),
    id:changeNominatorData.id,
    director: getDirectorData(changeNominatorData),
        
    // nominator
    isNomineeDirector: changeNominatorData.is_nominee_director,
    nominatorType: changeNominatorData?.shareholder_type ? {
        text: changeNominatorData.shareholder_type.includes('Individual') ? NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL : NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE,
        value: changeNominatorData.shareholder_type.includes('Individual') ? NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL : NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE,
    } : undefined,
    isExistingNominator: changeNominatorData.is_existing_nominator,

    // existing nominator
    nominator: getNominatorData(changeNominatorData),
        
    // new nominator
    nominatorName: changeNominatorData?.shareholder?.user?.user_info?.legal_name ?? changeNominatorData?.shareholder?.user?.name,
    nominatorEmail: changeNominatorData?.shareholder?.user?.email,
    nominatorNRIC: changeNominatorData?.shareholder?.user?.user_info?.NRIC,
    nominatorIdType: changeNominatorData?.shareholder?.user?.user_info?.id_type ? {
        id: changeNominatorData?.shareholder?.user.user_info.id_type.id,
        name: changeNominatorData?.shareholder?.user.user_info.id_type.name,
    } : undefined,
    nominatorNationality: changeNominatorData?.shareholder?.user?.user_info?.nationality ? {
        value: changeNominatorData?.shareholder?.user.user_info.nationality.id,
        text: changeNominatorData?.shareholder?.user.user_info.nationality.name,
    } : undefined,
    nominatorDateOfExpiry: formatDate(changeNominatorData?.shareholder?.user?.user_info?.date_of_expiry),
    nominatorDOB: formatDate(changeNominatorData?.shareholder?.user?.user_info?.DOB),
    nominatorAddress: changeNominatorData?.shareholder?.user?.user_info?.address,
        
    nominatorUen: changeNominatorData?.shareholder?.uen,
    nominatorLegalForm: changeNominatorData?.shareholder?.legal_form,
    nominatorJurisdiction: changeNominatorData?.shareholder?.jurisdiction ? {
        id: changeNominatorData?.shareholder?.jurisdiction.id,
        name: changeNominatorData?.shareholder?.jurisdiction.name,
    } : undefined,
    nominatorStatue: changeNominatorData?.shareholder?.statue ? {
        id: changeNominatorData?.shareholder?.statue.id,
        name: changeNominatorData?.shareholder?.statue.name,
    } : undefined,
    nominatorRegistrar: changeNominatorData?.shareholder?.registrar ? {
        id: changeNominatorData?.shareholder?.registrar.id,
        name: changeNominatorData?.shareholder?.registrar.name,
    } : undefined,

    nominatorAlias: changeNominatorData?.shareholder?.alias,
});

export default localizeChangeNominator;